import React, { useEffect, useRef, useState } from 'react';
import { Button, message, Spin, Upload } from 'antd';
import { SDrawer, SGeneralForms } from 'shj-components';
import ImageUpload from '@/components/Upload/ImageUpload'
import { useFileUrlPrefix } from 'shj-utils';
import cardFront from '@/assets/cardFront.png';
import nationalEmblem from '@/assets/nationalEmblem.png';
import selfPositive from '@/assets/selfPositive.png';
import { IConfig } from 'shj-components/dist/es/SGeneralForms/type';
import { getImgRelativePath } from '@/utils';
import { editFile } from '@/services/externalPerson';

const vacationEdit = (props: any) => {
    const fileUrlPrefix = useFileUrlPrefix()
    const { visibleDrawer = false, title = '附件编辑', record, closeDetails, getDetail } = props
    const [spinLoading, setSpinLoading] = useState(false);
    const formRefs = useRef<any>();
    const imgUrlEditFn = (list) => {
        let imgList: any = [];
        list.forEach((item) => {
            imgList.push({
                uid: item,
                url: fileUrlPrefix + item,
                relativePath: item,
            })
        });
        return imgList;
    };
    const beforeUpload = (file: any) => {
        if ((file.type || '').startsWith('image')) {
            if (!file.name.endsWith('.jpg') && !file.name.endsWith('.bmp') && !file.name.endsWith('.png') && !file.name.endsWith('.jpeg')) {
                message.error('图片必须是jpg/jpeg/png/bmp格式')
                return Upload.LIST_IGNORE
            }
            return true
        }
        message.error('只能上传图片')
        return Upload.LIST_IGNORE
    }
    useEffect(() => {
        if (record?.idCardFrontUrl) {
            formRefs?.current?.onFormRef().setFieldsValue({
                idCardFrontUrl: imgUrlEditFn([record?.idCardFrontUrl]),
                employeePhotoUrl: imgUrlEditFn([record?.employeePhotoUrl]),
                idcardBackUrl: imgUrlEditFn([record?.idcardBackUrl])
            });
        }
    }, [visibleDrawer])

    const configs: Array<IConfig> = [
        {
            title: '身份信息',
            titleMode: 'drawer',
            formItem: [
                {
                    name: 'employeePhotoUrl',
                    label: '个人照片',
                    spanCol: 8,
                    required: true,
                    htmlFor: 'imgUrl',
                    children: <ImageUpload exampleImgSrc={selfPositive} limit={1} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload}/>,
                },
                {
                    name: 'idCardFrontUrl',
                    label: '身份证人面像',
                    spanCol: 8,
                    required: true,
                    htmlFor: 'imgUrl',
                    children: <ImageUpload exampleImgSrc={cardFront} limit={1} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload}/>,
                },
                {
                    name: 'idcardBackUrl',
                    label: '身份证国徽面',
                    spanCol: 8,
                    required: true,
                    htmlFor: 'imgUrl',
                    children: <ImageUpload exampleImgSrc={nationalEmblem} limit={1} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload}/>,
                }
            ],
        }]
    const onSubmit = () => {
        formRefs?.current?.onFormRef()?.validateFields().then(values => {
            setSpinLoading(true)
            let formObj = {
                id: record.id,
                idCardFrontUrl: getImgRelativePath(values.idCardFrontUrl[0]),
                idcardBackUrl: getImgRelativePath(values.idcardBackUrl[0]),
                employeePhotoUrl: getImgRelativePath(values.employeePhotoUrl[0])
            };
            editFile(formObj).then((res) => {
                message.success('操作成功')
                getDetail()
                closeDetails()
            }).catch(err => {
                message.error(err)
            }).finally(() => {
                setSpinLoading(false)
            })
        })
    };
    return (
        <>
            <SDrawer
                width={800}
                title={record?.idCardFrontUrl ? title : '附件新增'}
                open={visibleDrawer}
                onClose={closeDetails}
                destroyOnClose
                footer={<Button type="primary" onClick={onSubmit}>保存</Button>}
            ><Spin spinning={spinLoading}>
                    <SGeneralForms
                        ref={formRefs}
                        configs={configs}
                        layout={'vertical'}
                    />
                </Spin>
            </SDrawer>
        </>
    );
};
export default vacationEdit
